<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'等保测评'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center fz-24 serviceT mt-50">等保测评</p>
			<p class="t-align-center fz-24 serviceT mt-10 mb-20">Equal assurance evaluation</p>
			<div class="m-0auto maxw-1400 dp-f justify-between pb-50">
				<div>
					<p class="fz-24 f-blue line-50 f-bold">等保测评价值</p>
					<p class="t-indent2 line-26 fz-18">提高信息安全保障能力和水平，维护国家安全、社会稳定和公共利益，保障和促进信息化建设。通过信息系统定级，明确系统保密性、完整性、可用性的重要性要求，根据信息安全标准确立明确的安全防护目标。经过合理的信息安全分析，根据不同的安全性要求，设计整体的安全基础架构，从网络边界防御到内部安全控制，从而防止“水桶效应”的出现。通过构建信息安全组织架构和人员配备，结合企业安全现状，建立信息安全建设、日常维护、业务连续性等进行有效的制度和策略建设，合理进行贯彻和落实，紧密结合技术控制措施，实现企业信息安全体系化建设。</p>
					<img src="../../assets/img/service/u15.png" alt="">
				</div>
				<div>
					<div class="bg-blue t-align-center">
						<p class="fz-24 f-white f-bold">等保测评作用</p>
					</div>
					<div class="li-w">
						<li>深入了解信息系统的整体风险与不足；</li>
						<li>判定当前系统安全防护能力等级情况；</li>
						<li>了解信息化安全建设的需求和方向；</li>
						<li>达到监管机构相关政策要求；</li>
						<li>以“检查”方式促进“安全”；</li>
						<li>提高内部人员信息安全意识；</li>
						<li>测评结果具有较高的权威性和合规性；</li>
						<li>政府部门信息安全项目验收衡量标准；</li>
						<li>监督以往的建设实施情况；</li>
						<li>整体的产品资源规划、减少不必要的浪费；</li>
						<li>满足网络安全法第二十一条要求。</li>
					</div>
				</div>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
.maxw-1400>div{
	width: 48%;
}
.maxw-1400>div:first-child img{
	width: 100%;
	margin-top: 30px;
}
.maxw-1400>div:last-child{
	background-color: #effffc;
	height: inherit;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.bg-blue{
	background-color: #4264b5;
	height: 60px;
	line-height: 60px;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.li-w{
	padding: 30px;
	font-size: 18px;
	height: 96%;
	line-height: 300%;
	letter-spacing: 0.1em;
	color: #808080;
	display: flex;
	flex-direction: column;
}
li::marker{
	color: #4264b5;
	font-size: 2rem;
}
</style>